import { MapLogic } from "./MapLogic";
import { getjQuery } from "@serenity-is/corelib";

let $ = getjQuery();
$(function () {
    var dash = new MapLogic();
    dash.DisplayMarketInformation();
});
